module.exports = __webpack_public_path__ + "assets/img/AllInclusive_422_Fairown_1920x600_2.bdc63a66.jpg";